import React, { useEffect, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FirebaseContext } from "../lib/firebase";
import App from "./App";
import { useAuthState } from "react-firebase-hooks/auth";
import { useRole } from "../lib/userRole";
import { useForceRender } from "../lib/rerender";

function Init() {
  const [data, setData] = useState([]);
  const { auth, api } = useContext(FirebaseContext);
  const { getUserRole } = api;
  const [user, loading] = useAuthState(auth);
  const navigate = useNavigate();
  const { setRole } = useRole();
  const { forceRender, trigger } = useForceRender();

  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/");
    const getRole = async () => {
      const userRole = await getUserRole(user?.uid);
      setRole(userRole);
    };
    if (user) {
      getRole();
    }
  }, [user, loading, navigate, setRole, getUserRole]);

  useEffect(() => {
    const init = async () => {
      const structure = await api.getFiles();
      setData(structure);
    };

    init();
  }, [api, trigger]);

  return <App data={data} forceRender={forceRender} />;
}

export default Init;
